<template>
    <div :class="`user-gender ${gender === 2 && 'girl'}`">
        <svg-icon :class="`user-gender-icon`" :icon-class="gender === 2 ? 'woman' : 'man'" />
        <div class="user-age">{{age}}</div>
    </div>
</template>

<script>
export default {
    name: "gender",
    props: {
        gender: {
            type: Number,
            required: true,
            default: 0
        },
        age: {
            type: Number,
            required: true,
            default: 0
        }
    },
    computed: {},

    data() {
        return {};
    }
};
</script>

<style scoped lang="scss" >
@import "../../style/function.scss";
@import "../../style/config.scss";

.user-gender {
    width: 0.54rem;
    height: 0.28rem;

    border-radius: 0.28rem;
    font-weight: normal;
    line-height: normal;
    font-size: 0.2rem;

    display: inline-flex;
    justify-content: center;
    align-items: center;

    background: #def0fe;
    color: #189cff;
    &.girl {
        background: #fedeee;
        color: #fe1caf;
    }
}
</style>
